<template>
  <transition name="fade" mode="out-in">
    <slot />
  </transition>
</template>

<script>
export default {
  name: "FadeTransition",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      import_to_file:
        "import FadeTransition from '@/components/transitions/FadeTransition';"
    };
  },
  created() {}
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
